import axios, { AxiosResponse } from 'axios';
import { BASE_URL } from '../../config/environmentConfig';

const LOGIN_URL = `${BASE_URL.IDENTITY}/identity/signin`;
const LOGOUT_URL = `${BASE_URL.IDENTITY}/identity/sign-out`;

export function login(email: string, password: string, recaptchaToken: any): Promise<AxiosResponse<any>> {
	return axios.post(LOGIN_URL, {
		email,
		password,
		recaptchaToken
	},
		{
			withCredentials: true, // This is crucial for saving cookies from the response
			headers: {
				'Content-Type': 'application/json'
			}
		});
}

export function logout(token: string): Promise<AxiosResponse<any>> {
	return axios.post(LOGOUT_URL, {
		token
	});
}


// Server should return object => { result: boolean } (Is Email in DB)
// export function requestPassword(email: string) {
// 	return axios.get<{ result: boolean }>(REQUEST_PASSWORD_URL, {
// 		params: {
// 			email: email
// 		}
// 	});
// }
